// extracted by mini-css-extract-plugin
module.exports = {"article":"article-list-module--article--14l3R","ul":"article-list-module--ul--1_V__","article__link":"article-list-module--article__link--2uvHJ"};